import {
    TEnvironmentSettings,
    getCombinedAppAndDefaultEnvironmentSettings,
} from '@pb/services';
import { TAppEnvironmentSettings, TEnvironment } from './environment.types';

const development: TAppEnvironmentSettings = {
    baseApiUrl: 'http://localhost:8081',
};

const qa: TAppEnvironmentSettings = {
    baseApiUrl: 'https://qa.pbr.so',
};

const production: TAppEnvironmentSettings = {
    baseApiUrl: 'https://api.purplebricks.co.uk',
};

const appEnvironmentSettings: Record<TEnvironment, TAppEnvironmentSettings> = {
    development,
    qa,
    production,
};

export function getAppEnvironmentSettings(): TEnvironmentSettings &
    TAppEnvironmentSettings {
    return getCombinedAppAndDefaultEnvironmentSettings<TAppEnvironmentSettings>(
        appEnvironmentSettings
    );
}
